/* eslint-disable react/prop-types */

import React from 'react';
import styled from 'styled-components';
import { components as Base } from 'react-select';
import Checkbox from './Checkbox';
import {
  Select,
  ClearIndicator,
  Control,
  MultiValueRemove,
  Option,
} from './Select';

/**
 * Custom option component
 */
const Toggle = styled(Checkbox)`
  align-items: center;
  display: flex;
`;

const Label = styled.span`
  color: var(--dropdown-text);
  font-weight: var(--normal);
`;

function CheckboxOption({ children, getValue, ...props }) {
  const { data } = props;
  const value = getValue();

  // Check whether current option is a selected value
  const checked = value.includes(data);

  return (
    <Option {...props}>
      <Toggle checked={checked}>
        <Label>{children}</Label>
      </Toggle>
    </Option>
  );
}

/**
 * Custom value container component
 */
const Selected = styled.span`
  color: var(--dropdown-text);
`;

const Remaining = styled.span`
  color: var(--dropdown-text);
  margin-left: 4px;
`;

function CheckboxValueContainer({ children, getValue, ...props }) {
  const [, input] = children;
  const value = getValue();

  // Get the count of values selected
  const count = value.length;

  return (
    <Base.ValueContainer {...props}>
      {
        // If no values are selected, render default children
        count === 0 && children
      }

      {
        // Otherwise if there are values selected, intercept the first child
        // which are the default multi value tags and instead render the first
        // selected and the remaining count. Also render the second child which
        // is the dummy input that handles the other event behaviors
        count > 0 && (
          <>
            <Selected>{value[0].label}</Selected>
            {count > 1 && <Remaining>+{count - 1}</Remaining>}
            {input}
          </>
        )
      }
    </Base.ValueContainer>
  );
}

/**
 * Checkbox multi select
 */
function CheckboxSelect({ components, ...props }) {
  return (
    <Select
      {...props}
      blurInputOnSelect={false}
      closeMenuOnSelect={false}
      components={{
        ...components,
        ClearIndicator,
        Control,
        MultiValueRemove,
        Option: CheckboxOption,
        ValueContainer: CheckboxValueContainer,
      }}
      hideSelectedOptions={false}
      isClearable
      isMulti
      isSearchable={false}
    />
  );
}

export default styled(CheckboxSelect)``;
